module.exports = __webpack_public_path__ + "assets/img/title-a7df6a7e.png";